import React, { ComponentType } from 'react';

import { Node, FreshNode, DragFuncRule, DropFuncRule, MoveFuncRule } from '../interfaces';
import { NodeProvider } from '../nodes';
import { getRandomId } from './getRandomId';

const getNodeTypeName = (type: string | { name: string }) => (typeof type == 'string' ? type : type.name);
export function createNode(newNode: FreshNode, normalize?: (node: Node) => void) {
    const actualType = newNode.data.type;
    const id = newNode.id || getRandomId();
    const node: Node = {
        id,
        _hydrationTimestamp: Date.now(),
        data: {
            name: getNodeTypeName(actualType),
            displayName: getNodeTypeName(actualType),
            props: {},
            custom: {},
            parent: '',
            hidden: false,
            nodes: [],
            linkedNodes: {},
            ...newNode.data,
        },
        related: {},
        events: {
            selected: false,
            dragged: false,
            hovered: false,
        },
        rules: {
            canDrag: () => true,
            canDrop: () => true,
            canMoveIn: () => false,
            canMoveOut: () => true,
        },
        configs: {},
        dom: null,
    };

    if (normalize) {
        normalize(node);
    }

    const settings = actualType.settings;

    if (settings) {
        node.data.displayName = settings.displayName || node.data.displayName;

        node.data.props = {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...(actualType.defaultProps || {}),
            ...node.data.props,
        };
        node.data.custom = {
            ...(settings.custom || {}),
            ...node.data.custom,
        };

        if (settings.rules) {
            for (const [key, value] of Object.entries(settings.rules)) {
                if (key === 'canDrag') {
                    node.rules.canDrag = value as DragFuncRule;
                } else if (key === 'canDrop') {
                    node.rules.canDrop = value as DropFuncRule;
                } else if (key === 'canMoveIn' || key === 'canMoveOut') {
                    node.rules[key] = value as MoveFuncRule;
                }
            }
        }

        if (settings.related) {
            const relatedNodeContext = {
                id: node.id,
                related: true,
            };

            Object.keys(settings.related).forEach((comp) => {
                if (settings.related && settings.related[comp]) {
                    const element = settings.related[comp] as ComponentType;
                    node.related[comp] = (props) =>
                        React.createElement(NodeProvider, relatedNodeContext, React.createElement(element, props));
                }
            });
        }
    }
    return node;
}
